import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Edit2, Trash2, X, Check } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from '../../../../common'

export const TableHouses = ({ useFetchInit }) => {
    
    const {
        FetchData,
        Actions
    } = useFetchInit

    const { fetchAllHouses } = FetchData
    const { dataHouses, loadingFetchAllHouses } = fetchAllHouses

    const { 
        handleClickFetchSpecificHouse,
        handleClickEnableHouse,
        handleClickDisableHouse,
        handleClickDeleteHouse
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { 
            field: "disponibilidad", 
            headerName: "DISPONIBILIDAD", 
            minWidth: 170,
            maxWidth: 170,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "left"
            }),
            cellClass: (params) => {
                if(params.value === 'DESOCUPADO') return 'bg-success';
                if(params.value === 'SOLICITADO') return 'bg-warning';
                if(params.value === 'OCUPADO') return 'bg-danger';
            },
            cellRenderer: (params) => {
                const { value } = params

                if(value === 'DESOCUPADO') return (
                    <span><i className="fa-solid fa-circle-check"></i> DESOCUPADO</span>
                );

                if(value === 'SOLICITADO') return (
                    <span><i className="fa-solid fa-clock"></i> SOLICITADO</span>
                );

                if(value === 'OCUPADO') return (
                    <span><i className="fa-solid fa-circle-xmark"></i> OCUPADO</span>
                );

            }
        },
        { field: "descripcion_corta", headerName: "DESCRIPCION CORTA", minWidth: 250, filter: true },
        { field: "direccion", headerName: "DIRECCIÓN", minWidth: 250, filter: true },
        {
            field: "costo_alquiler", headerName: "ALQUILER (Q)", filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idcasa, estado } = params.data

                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        {(estado === 1) && (
                            <div>
                                <MenuItem
                                    onClick={() => handleClickFetchSpecificHouse(idcasa)}
                                >
                                    <ListItemIcon> <Edit2 color="black"/> </ListItemIcon>
                                    <ListItemText primary="Informacion" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickDeleteHouse(idcasa)}
                                >
                                    <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                                    <ListItemText primary="Eliminar" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickDisableHouse(idcasa)}
                                >
                                    <ListItemIcon> <X color="black"/> </ListItemIcon>
                                    <ListItemText primary="Desactivar" />
                                </MenuItem>
                            </div>
                        )}
                        {(estado === 0) && (
                            <MenuItem
                                onClick={() => handleClickEnableHouse(idcasa)}
                            >
                                <ListItemIcon> <Check color="black"/> </ListItemIcon>
                                <ListItemText primary="Activar" />
                            </MenuItem>
                        )}
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchAllHouses)&&(<LinearLoading />)}
            <CustomTableData
                rowConfig={dataHouses}
                columnConfig={columnConfig}
            />
        </div>
    )
}
